module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_CertificateDocument2_16"],"path":[{"$":{"d":"M16,10a3,3,0,1,0-5,2.22V16l2-2,2,2V12.22A3,3,0,0,0,16,10ZM13,8.2A1.8,1.8,0,1,1,11.2,10,1.8,1.8,0,0,1,13,8.2ZM9,6H5V5H9Zm0,8v2H1V0h9l5,4V6a4.45,4.45,0,0,0-2-.49V5L9.3,2H3V14Zm.67-7A4.48,4.48,0,0,0,9,8H5V7Zm-1,2a4.49,4.49,0,0,0-.12,1H5V9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_CertificateDocument2_16.svg
// module id = Hs+t
// module chunks = 1